import { MenuItem } from "@mui/material";

import { IRules, IRulesCharge } from "../../Setup.types";
import { Container, Row, SelectForm } from "./Rules.styled";

interface IProps {
  rules: IRules;
  handleChange: (payload: Partial<IRules>) => void;
}

export function RulesTabCharge({ rules, handleChange }: IProps) {
  /** Função responsável especificamente por receber os valores alterados e formatar corretamente para handleChange. */
  function handleChangeCharge(payload: Partial<IRulesCharge>) {
    const updatedChargeFields = { ...rules.rulesCharge, ...payload };

    handleChange({ ...rules, rulesCharge: updatedChargeFields });
  }

  return (
    <Container>
      <Row>
        <SelectForm
          label="Aposentado cobrado direto p/ seguradora"
          value={rules.rulesCharge.chargedFromInsurance === true ? "SIM" : rules.rulesCharge.chargedFromInsurance === false ? "NAO" : undefined}
          onChange={(e) => handleChangeCharge({ chargedFromInsurance: e.target.value === "SIM" ? true : false })}
        >
          <MenuItem value={"SIM"}>Sim</MenuItem>
          <MenuItem value={"NAO"}>Nao</MenuItem>
        </SelectForm>
      </Row>
    </Container>
  );
}
